import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentStepState} from '../../shared/map.state';
import {Observable, throwError} from 'rxjs';
import {Actions, ofActionDispatched, Select} from '@ngxs/store';
import {catchError, filter} from 'rxjs/operators';
import {SetPaymentStepOtt} from '../../shared/map.actions';
import {Session} from '../../../interfaces/session-data';
import {TransactionService} from '../../../services/transaction/transaction.service';

@Component({
  selector: 'app-mobicred',
  templateUrl: './mobicred.component.html',
  styleUrls: ['./mobicred.component.scss']
})
export class MobicredComponent implements OnInit {

  // loader
  color: ThemePalette = 'primary';
  value = 50;
  diameter = 60;

  // ngxs
  @Select(PaymentStepState) paymentStep$: Observable<object>;

  public paymentMethodStyling;
  public backButtonVisibility;
  public paymentMethod: string = "mobicred";
  public paymentOptionsLoadedJustify = 'space-between !important';
  public username = new FormControl('', [Validators.required, Validators.email]);
  public password: string;
  public otp = new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]);
  public mobicredLoginForm: FormGroup;
  public hide = true;
  public paymentStatus: String = '';
  public transactionStatus: String = '';
  public paymentStatusImgSrc: String = '';
  paymentMethodImg: string = "";
  public session: Session;
  otpState = false;
  // routes
  timeRemaining;
  // loading var
  public loading: boolean = true;

  // box-shadow
  public boxShadow = '0px 6px 12px 0px rgba(0,0,0,0.5 )';
  hidePgLogo = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private actions$: Actions,
    private transactionService: TransactionService
    ) {
      this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_step_one.png`;
      sessionStorage.setItem('selected-payment', 'mobicred');
      this.session = JSON.parse(sessionStorage.getItem('sessionData'));

      router.events
      .pipe(
        filter(
          (events) => {
            return (events instanceof NavigationStart);
          }
        )
      )
      .subscribe((events: NavigationStart) => {
        if (events.navigationTrigger === 'popstate') {
          this.router.navigate([this.session.virtualRoute])
            .then((data) => {
              this.loading = false;
            });
        }
      });

      this.actions$
      .pipe(ofActionDispatched(SetPaymentStepOtt))
      .subscribe(({ payload }) => this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_${payload.toLowerCase()}.png`);

      }

  getTimeRemaining(timeRemaining) {
    this.timeRemaining = timeRemaining;
    this.otpState = true;
  }

  ngOnInit(): void {
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    this.hidePgLogo = this.session?.sessionDisplayInformation?.hidePgLogo === 'true';
    if (this.router.routerState.snapshot.url.indexOf(`${this.paymentMethod}/`) === -1) {
      // setTimeout(() => {
      this.loading = false;
      this.router.navigate(['virtual/mobicred/login']);
      // }, 2000);
    } else {
      this.loading = false;
    }

    this.paymentStep$.pipe(
      catchError((err) => {
        return throwError(err);
      })
    );


  }

  goBack(){
    this.router.navigate(['virtual']);
    sessionStorage.setItem("goBack", "true");
  }

}
